<template>
  <!-- Ajustei o padding vertical para ser mais consistente e adicionei a fonte Inter -->
  <footer class="bg-neutrals_surface py-10 md:py-12 text-neutrals_text font-inter"> 
    <div class="container mx-auto px-6 max-w-7xl">
      
      <!-- O grid agora é uma única coluna por padrão (móvel) e se transforma em 2 ou 4 colunas em telas maiores -->
      <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">

        <!-- 1. Localização -->
        <!--<div class="text-center md:text-left">
          <h4 class="text-xl font-bold mb-4 text-primary border-b-2 border-primary pb-1 inline-block">Localização</h4>
          <address class="not-italic text-neutrals_muted leading-relaxed text-sm">
            <p>{{ enterprise?.address }}, {{ enterprise?.number }}</p>
            <p>{{ enterprise?.neighborhood }}, {{ enterprise?.city }} - {{ enterprise?.state }}</p>
            <p>CEP: {{ enterprise?.zip_code }}</p>
          </address>
        </div>-->

        <!-- 2. Fale Conosco -->
        <div class="text-center md:text-left">
          <h4 class="text-xl font-bold mb-4 text-primary border-b-2 border-primary pb-1 inline-block">Fale Conosco</h4>
          <ul class="text-neutrals_muted leading-relaxed space-y-2 text-sm">
            <li class="flex items-center space-x-2 justify-center md:justify-start">
              <!-- Ícone de Telefone (Exemplo: se lucide-react estivesse disponível, mas usando um placeholder simples) -->
              <!-- <i data-lucide="phone" class="w-4 h-4 text-primary"></i> -->
              <a :href="`tel:${enterprise?.phone}`" class="hover:text-primary transition">{{
                formatPhone(enterprise?.phone) }}</a>
            </li>
            <li class="flex items-center space-x-2 justify-center md:justify-start">
              <!-- Ícone de Email -->
              <!-- <i data-lucide="mail" class="w-4 h-4 text-primary"></i> -->
              <a :href="`mailto:${enterprise?.email}`" class="hover:text-primary transition">{{ enterprise?.email }}</a>
            </li>
          </ul>
        </div>

        <!-- 3. Navegação -->
        <div class="text-center md:text-left">
          <h4 class="text-xl font-bold mb-4 text-primary border-b-2 border-primary pb-1 inline-block">Navegação</h4>
          <ul class="text-neutrals_muted leading-relaxed space-y-1 text-sm">
            <li><router-link to="/" class="hover:text-primary transition">Início</router-link></li>
            <li><router-link to="/categorias" class="hover:text-primary transition">Categorias</router-link></li>
            <li><router-link to="/contato" class="hover:text-primary transition">Contato</router-link></li>
          </ul>
        </div>

        <!-- 4. Siga-nos -->
        <div class="text-center md:text-left">
          <h4 class="text-xl font-bold mb-4 text-primary border-b-2 border-primary pb-1 inline-block">Siga-nos</h4>
          <div class="flex space-x-4 justify-center md:justify-start">

            <!-- WhatsApp -->
            <a v-if="enterprise?.phone" :href="`https://wa.me/55${enterprise.phone.replace(/\D/g, '')}`" target="_blank"
              aria-label="WhatsApp" class="text-neutrals_muted hover:text-success transition rounded-full p-1 bg-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="w-6 h-6">
                <path
                  d="M12.04 2C6.5 2 2 6.5 2 12.04c0 1.84.48 3.62 1.39 5.2L2 22l4.9-1.28A9.97 9.97 0 0 0 12.04 22C17.55 22 22 17.55 22 12.04S17.55 2 12.04 2zm0 18.21a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-2.48.64.66-2.57-.17-.27A8.13 8.13 0 0 1 3.84 12c0-4.54 3.68-8.21 8.2-8.21 2.19 0 4.25.86 5.8 2.42a8.16 8.16 0 0 1 2.4 5.79c0 4.53-3.68 8.21-8.2 8.21zm4.56-6.17c-.25-.12-1.47-.72-1.7-.8-.23-.08-.4-.12-.57.12-.17.25-.65.8-.8.96-.15.17-.3.19-.55.08-.25-.12-1.06-.39-2.02-1.24-.74-.66-1.24-1.48-1.38-1.73-.14-.25-.01-.39.11-.52.12-.12.25-.3.37-.45.12-.15.16-.25.25-.42.08-.17.04-.32-.02-.45-.06-.12-.57-1.37-.78-1.88-.21-.5-.43-.43-.57-.44h-.48c-.17 0-.44.06-.67.32-.23.25-.88.86-.88 2.09 0 1.22.9 2.4 1.03 2.56.13.17 1.78 2.71 4.32 3.8.6.26 1.06.42 1.42.54.6.19 1.14.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.22-.17-.47-.29z" />
              </svg>
            </a>


            <!-- Instagram -->
            <a href="https://www.instagram.com/seuusuario" target="_blank" aria-label="Instagram"
              class="text-neutrals_muted hover:text-accent transition rounded-full p-1 bg-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-6 h-6">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>

            </a>
          </div>
        </div>

      </div>
      
    </div>
  </footer>
</template>

<script setup>
const props = defineProps({
  enterprise: {
    type: Object,
    default: () => ({}),
  },
});

function formatPhone(phone) {
  if (!phone) return "";

  const cleaned = ("" + phone).replace(/\D/g, "");

  const match11 = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);
  if (match11) return `(${match11[1]}) ${match11[2]}-${match11[3]}`;

  const match10 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (match10) return `(${match10[1]}) ${match10[2]}-${match10[3]}`;

  return phone;
}
</script>

<style scoped>
/* Adicionando a fonte Inter para o AppFooter */
.font-inter {
    font-family: 'Inter', sans-serif;
}
</style>